import { withApollo } from "react-apollo";

import { getListOfTransactionsQuery } from "../../../services/graphql/queries/auto-numbering";
import { PAGINATION_OFFSET_VALUE } from "../../../constants/app-constants";
import React from "react";
class AutoNumberingFilter extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      userId: "",
      name: "",
      emailId: "",
      errors: []
    };

    this.submitForm = this.submitForm.bind(this);
    this.resetForm = this.resetForm.bind(this);
  }

  componentDidMount() {
    this.initialState = this.state;
  }

  resetForm() {
    this.setState({ errors: [] });
    this.setState({ ...this.initialState });

    this.props.client
      .query({
        query: getListOfTransactionsQuery,
        variables: {
          offset: PAGINATION_OFFSET_VALUE,
          pageNo: 1
        },
        fetchPolicy: "network-only"
      })
      .then(result => {
        this.setState({ loading: false, error: "" });
        this.props.listData(result.data.getListofTransaction);
        this.props.displayFilter();
        console.log("~~~result: ", result.data.getListofTransaction);
      })
      .catch(error => {
        console.log("~~~error: ", error);
        this.setState({ loading: false, error: error.message });
      });
  }

  submitForm() {
    //Use below variables to Update DB via GraphQL after all validations pass
    const { userId, name, emailId } = this.state;

    this.setState({ errors: [] });
    let requiredChecksPassed = true;

    this.props.client
      .query({
        query: getListOfTransactionsQuery,
        variables: {
          offset: PAGINATION_OFFSET_VALUE,
          pageNo: this.state.currentPage,
          shortDescription: userId.trim()
        },
        fetchPolicy: "network-only"
      })
      .then(result => {
        this.setState({ loading: false, error: "" });
        this.props.listData(result.data.getListofTransaction);
        this.props.displayFilter();
        console.log("~~~result: ", result.data.getListofTransaction);
      })
      .catch(error => {
        console.log("~~~error: ", error);
        this.setState({ loading: false, error: error.message });
      });
  }

  render() {
    const { showFilter } = this.props;
    const { userId, name, emailId } = this.state;

    return (
      <div
        className="filter-popup"
        style={
          showFilter
            ? {
                display: "block",
                top: 220,
                right: 80,
                zIndex: 999
              }
            : { display: "none" }
        }
      >
        <h4>FILTER</h4>
        <form className="m-t-15">
          <div className="form-group">
            <label>TRANSACTION TYPE</label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Transaction Type"
              value={userId}
              onChange={e => {
                this.setState({ userId: e.target.value });
              }}
            />
          </div>

          <div className="row">
            <div className="col-md-6 text-center">
              <button
                type="button"
                className="btn btn-light btn-block"
                onClick={this.resetForm}
              >
                Clear
              </button>
            </div>
            <div className="col-md-6 text-center">
              <button
                type="button"
                className="btn btn-danger btn-block"
                onClick={this.submitForm}
              >
                Apply
              </button>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

export default withApollo(AutoNumberingFilter);
